export default "__VITE_ASSET__C$AxSVVM__"